export default __webpack_public_path__ + "static/media/urban.432b397b.png";